import { render } from "./FooterImpresso.vue?vue&type=template&id=7db787b0&scoped=true"
import script from "./FooterImpresso.vue?vue&type=script&lang=js"
export * from "./FooterImpresso.vue?vue&type=script&lang=js"

import "./FooterImpresso.vue?vue&type=style&index=0&id=7db787b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db787b0"]])

export default __exports__